<template>
  <div>
    <vxe-form
        ref="xForm1"
        class="my-form2"
        title-align="right"
        title-width="150"
        :data="formData"
        :rules="formRules"
        @submit="submitEvent"
        @reset="cancelEvent"
    >
      <vxe-form-item title="销售人员" field="salesManager" span="24" v-if="!isInAdd">
        <Select v-model="formData.salesManagerId" clearable filterable label-in-value @on-change="checkSalesManager"
                placeholder="请选择销售人员">
          <Option
              v-for="item in salesManageList"
              :value="item.value"
              :key="item.value"
          >{{ item.label }}
          </Option>
        </Select>
      </vxe-form-item>
      <vxe-form-item title="收款人" field="recName" span="24">
        <template v-slot="scope">
          <vxe-input v-model="formData.recName" placeholder="请输入收款人" clearable
                     @input="$refs.xForm1.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="手机号码" field="phoneNum" span="24">
        <template v-slot="scope">
          <vxe-input v-model="formData.phoneNum" placeholder="请输入手机号码" clearable
                     @input="$refs.xForm1.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份证号码" field="idcardNum" span="24">
        <template v-slot="scope">
          <vxe-input v-model="formData.idcardNum" placeholder="请输入身份证号码" clearable
                     @input="$refs.xForm1.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="开户银行" field="bankName" span="24">
        <template v-slot="scope">
          <vxe-pulldown ref="bankDown" transfer style="width: 100%">
            <template v-slot>
              <vxe-input
                  v-model="formData.bankName"
                  placeholder="请选择开户银行"
                  @focus="bankFocusEvent"
                  @keyup="bankKeyupEvent"
                  @blur="checkOrg(scope)"
              >
                <template #suffix>
                  <div class="input-inner-switch">
                    <em>手动输入</em>
                    <vxe-switch @change="changeSwitch" v-model="isInputBank" open-label="是"
                                close-label="否"></vxe-switch>
                  </div>
                </template>
              </vxe-input>
            </template>
            <template v-slot:dropdown>
              <div class="my-dropdown1">
                <div
                    class="list-item1"
                    v-for="item in bankList"
                    :key="item.id"
                    @click="bankSelectEvent(item, scope)"
                >
                  <i class="fa fa-user-o"></i>
                  <span>{{ item.orgName }}</span>
                </div>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      <span class="bank-tip"><Icon type="ios-information-circle-outline"/>若未查询到开户行，请切换到手动输入</span>
      <vxe-form-item title="银行账号" field="accountNum" span="24">
        <template v-slot="scope">
          <vxe-input v-model="formData.accountNum" placeholder="请输入银行账号" clearable
                     @input="$refs.xForm1.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item align="right" span="24">
        <template v-slot>
          <vxe-button type="reset">取消</vxe-button>
          <vxe-button type="submit" status="primary">保存</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>
<script>
import {isEmpty} from "@/utils/util";
import $api from "@/apiProvider";

export default {
  props: {
    isInAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      formRules: {
        salesManager: [{required: true, message: "请选择销售人员"}],
        recName: [{required: true, message: "请输入收款人"}],
        phoneNum: [{required: true, message: "请输入手机号码"}],
        idcardNum: [{required: true, message: "请输入身份证号码"}],
        bankName: [{required: true, message: "请选择或输入开户账号"}],
        accountNum: [{required: true, message: "请输入银行账号"}],
      },
      bankList: [],
      isInputBank: false,
      bankName: null,
      salesManageList: [],
    }
  },
  mounted() {
    this.querySalesManage();
  },
  methods: {
    setSalesManager(salesManager, salesManagerId) {
      this.formData.salesManager = salesManager;
      this.formData.salesManagerId = salesManagerId;
    },
    setUpdate(row) {
      this.formData = Object.assign({}, row);
    },
    async checkSalesManager(e) {
      if (e) {
        this.formData.salesManager = e.label;
        this.formData.salesManagerId = e.value;
        let res = await $api.baseUserSalesManager.request("querySalesManagerNameList");
        if (res.status === 1) {
          let nameList = res.data;
          nameList.some(i => {
            if (i === e.label.trim()) {
              this.$XModal.message({
                message: '销售人员已存在，请前往编辑',
              });
              this.formData.salesManager = null;
              this.formData.salesManagerId = null;
              return true;
            }
          })
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error"
          });
        }
      }
    },
    clearV() {
      this.$refs.xForm1.clearValidate();
    },
    async querySalesManage() {
      let self = this;
      self.salesManageList = [];
      let data = {
        type: 2
      };
      let response = await $api.baseUserSales.request(
          "querySalesSelectQuick",
          data
      );
      if (response.status === 1) {
        let res = response.data;
        res.forEach(function (item, index) {
          var obj = {};
          obj.value = item.id;
          obj.label = item.text;
          self.salesManageList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    async submitEvent() {
      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.formData.phoneNum);
      if (!validPhone) {
        this.$XModal.alert({
          message: "请输入正确的手机号",
          status: "error",
        });
        return
      }
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      let validIDre = _IDRe18.test(this.formData.idcardNum) || _IDre15.test(this.formData.idcardNum);
      if (this.formData.idcardNum && this.formData.idcardNum !== '' && this.formData.idcardNum.length !== 18 && !validIDre) {
        this.$XModal.alert({
          message: "请输入正确的身份证号码",
          status: "error",
        });
        return
      }

      this.formData.recName = this.formData.recName.trim();
      this.formData.salesManager = this.formData.salesManager.trim();
      this.formData.isInAdd = this.isInAdd ? 1 : 0;
      if (this.formData.id) {
        let res = await $api.baseUserSalesManager.request("updateSalesManager", this.formData);
        if (res.status === 1) {
          this.$Message.success('保存成功');
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error"
          });
        }
      } else {
        let res = await $api.baseUserSalesManager.request("createSalesManager", this.formData);
        if (res.status === 1) {
          this.$Message.success('保存成功');
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error"
          });
        }
      }
    },
    cancelEvent() {
      this.$emit('close');
    },
    changeSwitch(val) {
      this.$set(this.formData, 'bankName', '');
      this.$refs.bankDown.hidePanel();
    },
    checkOrg(scope) {
      if (!this.isInputBank) {
        this.bankName = this.formData.bankName;
        this.formData.bankName = "";
        this.$refs.xForm1.updateStatus(scope);
      }
    },
    bankFocusEvent() {
      if (!this.isInputBank) {
        this.$refs.bankDown.showPanel();
      }
    },
    bankKeyupEvent() {
      if (!this.isInputBank) {
        this.clearV();
        this.chooseBank = false;
        this.getBankListByName();
      }
    },
    bankSelectEvent(obj) {
      this.clearV();
      this.formData.bankName = obj.orgName;
      this.$refs.bankDown.hidePanel();
    },
    bankBlurEvent(obj) {
      this.getBankListByName();
      if (this.bankList.length === 1) {
        this.formData.bankName = obj.orgName;
      } else {
        this.formData.bankName = null;
      }
    },
    async getBankListByName() {
      let name = this.formData.bankName;
      if (isEmpty(name)) {
        this.bankList = [];
        return
      }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status === 1 && name === res.message) {
        this.bankList = res.data;
      }
    },
  }
}
</script>
<style>
.input-inner-switch {
  width: 100px;
  position: absolute;
  right: 0;
  top: 0;
  height: 34px;
}

.input-inner-switch .vxe-switch {
  position: absolute;
  right: -5px;
  top: 0;
}

.input-inner-switch em {
  font-size: 12px;
  height: 100%;
  line-height: 34px;
  display: inline-block;
  color: #606266;
}

.bank-tip {
  display: block;
  color: #f00;
  padding-left: 150px;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1 {
  padding: 5px;
  cursor: pointer;
}

.list-item1:hover {
  background-color: #f5f7fa;
}
</style>